import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { Redirect } from 'react-router-dom';
import './NewsGrid.css';
import NewsModalSwitch from '../components/NewsModalSwitch';
import { getItemById } from '../lib/util';

class NewsGrid extends Component {
  constructor() {
    super();
    this.state = {
      currentPage: 1,
      newsPerPage: 10,
      paginationPerPage: 5,
    };
    this.gotoPage = this.gotoPage.bind(this);
    this.switchPage = this.switchPage.bind(this);
  }

  gotoPage(event) {
    this.setState({
      currentPage: Number(event.target.id),
    });
  }

  switchPage(event) {
    this.setState({
      currentPage:
        event.target.id === 'next' ? this.state.currentPage + 1 : this.state.currentPage - 1,
    });
  }

  render() {
    const { match } = this.props;
    // Logic for displaying current todos
    const indexOfLast = this.state.currentPage * this.state.newsPerPage;
    const indexOfFirst = indexOfLast - this.state.newsPerPage;
    let currentNews = this.props.news.slice(indexOfFirst, indexOfLast);
    if (match.params.filter && match.params.filter !== 'all' && match.params.filter !== 'detail') {
      currentNews = currentNews.filter(elem => elem.newstype ? elem.newstype.name === match.params.filter : false);
    }
    const shouldRedirect =
      this.props.news.length > 0 &&
      match.params.filter === 'detail' &&
      match.params.id &&
      !getItemById({
        id: match.params.id,
        array: this.props.news,
        key: 'id',
      });

    // Logic for displaying page numbers
    const totalPage = Math.ceil(this.props.news.length / this.state.newsPerPage);
    const pageNumbers = [];
    if (totalPage <= this.state.paginationPerPage) {
      for (let i = 1; i <= totalPage; i += 1) {
        pageNumbers.push(i);
      }
    } else {
      if (this.state.currentPage <= 3) {
        pageNumbers.push(1);
        pageNumbers.push(2);
        pageNumbers.push(3);
        pageNumbers.push('...');
        pageNumbers.push(totalPage);
      }
      if (this.state.currentPage > 3 && this.state.currentPage < totalPage - 2) {
        pageNumbers.push(1);
        pageNumbers.push('...');
        pageNumbers.push(this.state.currentPage - 1);
        pageNumbers.push(this.state.currentPage);
        pageNumbers.push(this.state.currentPage + 1);
        pageNumbers.push('...');
        pageNumbers.push(totalPage);
      }
      if (this.state.currentPage >= totalPage - 2) {
        pageNumbers.push(1);
        pageNumbers.push('...');
        pageNumbers.push(totalPage - 2);
        pageNumbers.push(totalPage - 1);
        pageNumbers.push(totalPage);
      }
    }
    const renderPagination = pageNumbers.map((number, idx) => {
      if (number === '...') {
        return (
          <li>
            <span className="pagination-ellipsis">&hellip;</span>
          </li>
        );
      }
      const classStr =
        this.state.currentPage === idx + 1 ? 'pagination-link is-current' : 'pagination-link';
      return (
        <li key={`pagination${idx + 1}`}>
          <a className={classStr} id={idx + 1} onClick={this.gotoPage}>
            {idx + 1}
          </a>
        </li>
      );
    });

    return (
      <div className="news-container">
        <div className="tile is-ancestor">
          <div className="tile is-vertical is-parent is-6">
            {currentNews.length > 0 && (
              <div className="tile is-child">
                {currentNews
                  .filter((elem, idx) => idx % 2 === 0)
                  .map(elem => (
                    <NewsModalSwitch
                      data={elem}
                      isShortNews={this.props.isShortNews}
                      key={elem.id}
                    />
                  ))}
              </div>
            )}
            {currentNews.length === 0 && <div className="news-placeholder" />}
          </div>
          <div className="tile is-vertical is-parent is-6">
            {currentNews.length > 0 && (
              <div className="tile is-child">
                {currentNews
                  .filter((elem, idx) => idx % 2 === 1)
                  .map(elem => (
                    <NewsModalSwitch
                      data={elem}
                      isShortNews={this.props.isShortNews}
                      key={elem.id}
                    />
                  ))}
              </div>
            )}
            {currentNews.length === 0 && <div className="news-placeholder" />}
          </div>
        </div>
        {this.props.enablePagination && (
          <nav className="pagination is-centered" aria-label="pagination">
            {totalPage > this.state.paginationPerPage && (
              <React.Fragment>
                <a className="pagination-previous" id="previous" onClick={this.switchPage}>
                  上一頁
                </a>
                <a className="pagination-next" id="next" onClick={this.switchPage}>
                  下一頁
                </a>
              </React.Fragment>
            )}
            <ul className="pagination-list">{renderPagination}</ul>
          </nav>
        )}
        {shouldRedirect && <Redirect to="/news/all" />}
      </div>
    );
  }
}
NewsGrid.propTypes = {
  news: PropTypes.arrayOf(PropTypes.object).isRequired,
  isShortNews: PropTypes.bool,
  enablePagination: PropTypes.bool,
  match: PropTypes.shape({
    params: PropTypes.shape({
      filter: PropTypes.string,
    }),
  }),
};

NewsGrid.defaultProps = {
  isShortNews: true,
  enablePagination: false,
  match: {
    params: {
      filter: '',
    },
  },
};

const mapStateToProps = state => ({
  news: state.news,
});

export default connect(mapStateToProps)(NewsGrid);



// WEBPACK FOOTER //
// ./src/containers/NewsGrid.js